<template>
	<div class="vx-row">

		<!-- HORIZONTAL LAYOUT -->
		<div class="vx-col md:w-1/2 w-full mb-base">
			<vx-card title="Edit Profile">
				<div class="vx-row mb-6">
					<div class="vx-col sm:w-1/3 w-full">
						<span>Title</span>
					</div>
					<div class="vx-col sm:w-2/3 w-full">
						<vs-select 
						placeholder="Select"
						data-vv-validate-on="blur" 
						name="title"
						v-model="title" class="w-full">
							<vs-select-item :key="item.value" :value="item.text" :text="item.text" v-for="item in titles" />
						</vs-select>
						<span class="text-danger text-sm">{{ errors.first('title') }}</span>
					</div>
				</div>
				<div class="vx-row mb-6">
					<div class="vx-col sm:w-1/3 w-full">
						<span>First Name</span>
					</div>
					<div class="vx-col sm:w-2/3 w-full">
						<vs-input 
						data-vv-validate-on="blur"
						name="firstName"
						 class="w-full" v-model="firstName" />
						<span class="text-danger text-sm">{{ errors.first('firstName') }}</span>
					</div>
				</div>
				<div class="vx-row mb-6">
					<div class="vx-col sm:w-1/3 w-full">
						<span>Last Name</span>
					</div>
					<div class="vx-col sm:w-2/3 w-full">
						<vs-input 
						data-vv-validate-on="blur" 
						name="lastName"
						class="w-full" v-model="lastName" />
						<span class="text-danger text-sm">{{ errors.first('lastName') }}</span>
					</div>
				</div>
				
				<div class="vx-row mb-6">
					<div class="vx-col sm:w-1/3 w-full">
						<span>Mobile</span>
					</div>
					<div class="vx-col sm:w-2/3 w-full">
						<vs-input class="w-full" 
						v-validate="'numeric'" 
						data-vv-validate-on="blur" 
						name="phone" 
						v-model="phone" />
						<span class="text-danger text-sm">{{ errors.first('phone') }}</span>
					</div>
				</div>
				<div class="vx-row mb-6">
					<div class="vx-col sm:w-1/3 w-full">
						<span>Position</span>
					</div>
					<div class="vx-col sm:w-2/3 w-full">
						<vs-select 
						autocomplete
						placeholder="Select"
						data-vv-validate-on="blur" 
						name="position"
						v-model="position" 
						class="w-full">
							<vs-select-item :key="item.value" :value="item.text" :text="item.text" v-for="item in positions" />
						</vs-select>
						<span class="text-danger text-sm">{{ errors.first('position') }}</span>
					</div>
				</div>
				<div class="vx-row mb-6">
					<div class="vx-col sm:w-1/3 w-full">
						<span>Level</span>
					</div>
					<div class="vx-col sm:w-2/3 w-full">
						<vs-select 
						placeholder="Select"
						data-vv-validate-on="blur" 
						name="positionLevel"
						v-model="positionLevel" class="w-full">
							<vs-select-item :key="item.value" :value="item.text" :text="item.text" v-for="item in positionLevels" />
						</vs-select>
						<span class="text-danger text-sm">{{ errors.first('positionLevel') }}</span>
					</div>
				</div>
				<div class="vx-row mb-6">
					<div class="vx-col sm:w-1/3 w-full">
						<span>Hire Status</span>
					</div>
					<div class="vx-col sm:w-2/3 w-full">
						<vs-select 
						placeholder="Select"
						data-vv-validate-on="blur" 
						name="hireStatus"
						v-model="hireStatus" class="w-full">
							<vs-select-item :key="item.value" :value="item.text" :text="item.text" v-for="item in hireStatuses" />
						</vs-select>
						<span class="text-danger text-sm">{{ errors.first('hireStatus') }}</span>
					</div>
				</div>
				<div class="vx-row mb-6">
					<div class="vx-col sm:w-1/3 w-full">
						<span>Job Function</span>
					</div>
					<div class="vx-col sm:w-2/3 w-full">
						<vs-input 
						data-vv-validate-on="blur"
						name="jobFunction"
						 class="w-full" v-model="jobFunction" />
						<span class="text-danger text-sm">{{ errors.first('jobFunction') }}</span>
					</div>
				</div>
				<div class="vx-row mb-6">
					<div class="vx-col sm:w-1/3 w-full">
						<span>Region</span>
					</div>
					<div class="vx-col sm:w-2/3 w-full">
						<vs-select 
						placeholder="Select"
						data-vv-validate-on="blur" 
						name="region"
						v-model="region" class="w-full">
							<vs-select-item :key="item.value" :value="item.text" :text="item.text" v-for="item in regions" />
						</vs-select>
						<span class="text-danger text-sm">{{ errors.first('region') }}</span>
					</div>
				</div>
				<div class="vx-row mb-6">
					<div class="vx-col sm:w-1/3 w-full">
						<span>City Area</span>
					</div>
					<div class="vx-col sm:w-2/3 w-full">
						<vs-select 
						placeholder="Select Region First"
						data-vv-validate-on="blur" 
						name="area"
						v-model="area" class="w-full">
							<vs-select-item :key="item.value" :value="item.text" :text="item.text" v-for="item in areas" />
						</vs-select>
						<span class="text-danger text-sm">{{ errors.first('area') }}</span>
					</div>
				</div>
				<div class="vx-row mb-6">
					<div class="vx-col sm:w-1/3 w-full">
						<span>Branch</span>
					</div>
					<div class="vx-col sm:w-2/3 w-full">
						<vs-select 
						placeholder="Select Aria First"
						v-model="branch" class="w-full">
							<vs-select-item :key="item.value" :value="item.text" :text="item.text" v-for="item in branches" />
						</vs-select>
					</div>
				</div>
				<div class="vx-row mb-6">
					<div class="vx-col sm:w-1/3 w-full">
						<span>English Level(Max 10)</span>
					</div>
					<div class="vx-col sm:w-2/3 w-full">
						<vs-select 
						placeholder="Select"
						v-model="engLevel" 
						class="w-full">
							<vs-select-item :key="item" :value="item" :text="item" v-for="item in [1,2,3,4,5,6,7,8,9,10]" />
						</vs-select>
					</div>
				</div>
				<div class="vx-row">
					<div class="vx-col sm:w-2/3 w-full ml-auto">
						<vs-button class="mr-3 mb-2" @click="submitFormEditProfile" :disabled="!isValidFormEditProfile">Save</vs-button>
					</div>
				</div>

			</vx-card>
		</div>

		<div class="vx-col md:w-1/2 w-full mb-base">
			<vx-card title="Change password">
				<div class="vx-row mb-6">
					<div class="vx-col sm:w-1/3 w-full">
						<span>Password</span>
					</div>
					<div class="vx-col sm:w-2/3 w-full">
						<vs-input
                                        ref="password"
                                        type="password"
                                        data-vv-validate-on="blur"
                                        v-validate="'min:6'"
                                        name="password"
                                        placeholder="Password"
                                        v-model="password"
                                        class="w-full" />
                                    <span class="text-danger text-sm">{{ errors.first('password') }}</span>
					</div>
				</div>
				<div class="vx-row mb-6">
					<div class="vx-col sm:w-1/3 w-full">
						<span>Confirm</span>
					</div>
					<div class="vx-col sm:w-2/3 w-full">
						<vs-input
                                        type="password"
                                        v-validate="'min:6|confirmed:password'"
                                        data-vv-validate-on="blur"
                                        data-vv-as="password"
                                        name="confirmPassword"
                                        placeholder="Confirm Password"
                                        v-model="confirmPassword"
                                        class="w-full" />
                                    <span class="text-danger text-sm">{{ errors.first('confirmPassword') }}</span>
					</div>
				</div>
				<div class="vx-row">
					<div class="vx-col sm:w-2/3 w-full ml-auto">
						<vs-button class="mr-3 mb-2" @click="submitFormChangePassword" :disabled="!isValidFormChangePassword">Save</vs-button>
					</div>
				</div>

			</vx-card>
		</div>

	</div>
</template>

<script>
import axios from 'axios'
import {API_BASE_URL, NAME_TITLE_TH} from '@/constants'

export default{
	data() {
		return {
			email: null,
			firstName: null,
			lastName: null,
			
			title: null,
			titles: [],

			phone: null,
			password: null,
			confirmPassword: null,
			
			position: null,
			positions: [],

			positionLevel: null,
			positionLevels: [],

			hireStatus: null,
			hireStatuses: [],
			jobFunction: null,
			engLevel: null,

			region: null,
			regions: [],
			area: null,
			areas: [],
			branch: null,
			branches: [],
		}
	},
	created() {

		this.titles = NAME_TITLE_TH;

		axios.get("/excise/regions.json")
		.then(response =>{
			this.regions = response.data;
		})
		.catch(error =>{
			console.log(error);
		});

		axios.get(API_BASE_URL+"api/excise/constants/ExcisePosition")
		.then(response =>{
			this.positions = response.data;
		})
		.catch(error =>{
			console.log(error);
		});

		axios.get(API_BASE_URL+"api/excise/constants/ExcisePositionLevel")
		.then(response =>{
			this.positionLevels = response.data;
		})
		.catch(error =>{
			console.log(error);
		});

		axios.get(API_BASE_URL+"api/excise/constants/ExciseHireStatus")
		.then(response =>{
			this.hireStatuses = response.data;
		})
		.catch(error =>{
			console.log(error);
		});

		axios.get(API_BASE_URL+"api/me")
		.then(response =>{
			console.log(response.data);
			this.email= response.data.exciseUserInfo.email;
			this.firstName= response.data.exciseUserInfo.firstName;
			this.lastName= response.data.exciseUserInfo.lastName;
			this.title= response.data.exciseUserInfo.title;
			this.phone= response.data.phoneNumber;
			this.position= response.data.exciseUserInfo.position;
			this.positionLevel= response.data.exciseUserInfo.positionLevel;
			this.hireStatus= response.data.exciseUserInfo.hireStatus;
			this.jobFunction= response.data.exciseUserInfo.jobFunction;
			this.engLevel= response.data.exciseUserInfo.engLevel;
			this.region= response.data.exciseUserInfo.region;
			this.area= response.data.exciseUserInfo.area;
			this.branch= response.data.exciseUserInfo.branch;
		})
		.catch(error =>{
			console.log(error);
		});
	},
	watch: {
		region(newVal, oldVal) {
			if(newVal != null) {
				const result = this.regions.find( it => it.text === newVal );
				this.areas = result.areas;
			}
		},
		area(newVal, oldVal) {
			if(newVal != null) {
				const result = this.areas.find( it => it.text === newVal );
				this.branches = result.branches;
			}
		},
		branch(newVal, oldVal) {
			
      	},
	},
	computed: {
        isValidFormEditProfile() {
            return !this.errors.any();
		},
		isValidFormChangePassword() {
            return !this.errors.any() && this.password != null && this.confirmPassword != null && this.password == this.confirmPassword;
        }
    },
	methods: {
		submitFormEditProfile() {
			this.$validator.validate().then(valid => {
				if (!valid) {
					this.$vs.notify({
						title: this.$t('Alert'),
						text: 'Please input all required data.',
						color:'danger',
						iconPack: 'feather',
						icon:'icon-alert-circle'
					});
					return;
				}
			});

			let profile = {
				email: this.email,
				firstName: this.firstName,
				lastName: this.lastName,
				title: this.title,
				phone: this.phone,
				position: this.position,
				positionLevel: this.positionLevel,
				hireStatus: this.hireStatus,
				jobFunction: this.jobFunction,
				engLevel: this.engLevel,
				region: this.region,
				area: this.area,
				branch: this.branch
				
			}

			console.log(profile);
			// return false;
			axios.put(API_BASE_URL + 'api/me', profile)
			.then(response => {
				console.log(response.data);
				this.$vs.notify({
					title: this.$t('Alert'),
					text: this.$t('Update user profile successfully'),
					color:'success',
					iconPack: 'feather',
					// position: 'top-center',
					icon:'icon-alert-circle'
				});
			})
			.catch(error => {
				console.log(error);
				this.$vs.notify({
					title: this.$t('Alert'),
					text: 'Error updating an profile, please contact admin',
					color:'danger',
					iconPack: 'feather',
					// position: 'top-center',
					icon:'icon-alert-circle'
				});
			});
		},
		submitFormChangePassword() {

			let payload = {
				password: this.password,
				confirmPassword: this.confirmPassword,
			}
			axios.put(API_BASE_URL + 'api/me/changePassword',payload)
			.then(response => {
				console.log(response);
				this.resetFormChangePassword();
				this.$vs.notify({
					title: this.$t('Alert'),
					text: this.$t('Update user password successfully'),
					color:'success',
					iconPack: 'feather',
					// position: 'top-center',
					icon:'icon-alert-circle'
				});
			})
			.catch(error => {
				console.log(error);
				this.$vs.notify({
					title: this.$t('Alert'),
					text: error.response.data.message,
					color:'danger',
					iconPack: 'feather',
					// position: 'top-center',
					icon:'icon-alert-circle'
				});
			});
		},
		resetFormChangePassword() {
			this.password = null;
			this.confirmPassword = null;
		},
		resetFormEditProfile() {
			this.email = null;
			this.firstName = null;
			this.lastName = null;
			this.title = null;
			this.phone = null;
			this.password = null;
			this.confirmPassword = null;
		}
	}
}
</script>
